import * as React from 'react';
import * as createFragment from "react-addons-create-fragment";
import * as moment from "moment";

import { isNullOrUndefined } from "../../utils";
import { IAppParams } from "../../models";
const styles = require('./Disclaimer.pcss');

interface IProps {
    disclaimer: {}[];
    useMatch?: boolean;
    appParams: IAppParams;
    date?: string;
    hideStatic?: boolean;
}

export class Disclaimer extends React.Component<IProps, {}>{
    constructor(props) {
        super(props);
    }

    findAndReplaceDate(date, text: { __html: string }) {
        if (date !== "" && !isNullOrUndefined(date)) {
            let fullDateRegExp = new RegExp(/\[\[DDMMYYYY]]/g);
            let yearRegExp = new RegExp(/\[\[YYYY]]/g);
            text.__html = text.__html
                .replace(fullDateRegExp, moment(date).format("DD.MM.YYYY"))
                .replace(yearRegExp, moment(date).format("YYYY"))
        }
        return text;
    }

    getDisclaimer() {
        let { disclaimer, appParams, useMatch, hideStatic } = this.props;
        let counter = 0;
        let match = new RegExp("[[THIS WILL NEVER EXIST]]");
        if (isNullOrUndefined(useMatch) || useMatch) {
            match = new RegExp(/(?:\r\n|\r|\n)/g);
        }

        let processedDisclaimers: any[] = [];
        for (let item of disclaimer) {
            if (item["disclaimers"]) {
                for (let disc of item["disclaimers"]) {
                    if (!disc.is_deleted) {
                        let arrDisclaimer = disc.disclaimer.split(match);
                        arrDisclaimer.map((d, index) => {
                            if (d.trim() !== "") {
                                processedDisclaimers.push(`<p key=${ counter }>${ d }</p>`);
                                ++counter;
                            }
                        });
                    }
                };
            } else {
                if (!item["is_deleted"]) {
                    let arrDisclaimer = item["disclaimer"].split(match);
                    arrDisclaimer.map((d, index) => {
                        if (d.trim() !== "") {
                            processedDisclaimers.push(`<p key=${ counter }>${ d }</p>`);
                            ++counter;
                        }
                    });
                }
            }
        }

        if (appParams.isprint && !hideStatic) {
            if (appParams.productrange.toLowerCase() === "ppl") {
                processedDisclaimers.push(`
                    <p>
                        M&G Investment Management Limited is registered in England and Wales under number 936683,
                        with registered offices at 10 Fenchurch Avenue, London EC3M 5AG. M&G Investment
                        Management Limited is authorised and regulated by the Financial Conduct Authority (“FCA”) and
                        is registered on the FCA’s register, No. 119328 (<a href="https://register.fca.org.uk/">https://register.fca.org.uk/</a>). It has passported
                        all appropriate licenses within the EEA. The FCA is located at 25 The North Colonnade, London,
                        UK, E14 5HS. Information on the FCA’s rules and guidance, including information about
                        passporting rights M&G Investment Management Limited has exercised, can be found at
                        www.fca.org.uk. Unless otherwise stated the portfolios of M&G Funds are managed by M&G
                        Investment Management Limited.
                    </p>
                    <p>
                        M&G Securities Limited is registered in England and Wales under number 90776, with registered
                        offices at 10 Fenchurch Avenue, London EC3M 5AG. M&G Securities is authorised and
                        regulated by the Financial Conduct Authority and is registered on the FCA’s register, No. 122057
                        (<a href="https://register.fca.org.uk/">https://register.fca.org.uk/</a>).
                    </p>
                    <p>
                        M&G Securities Limited and provides investment products.
                    </p>
                    <p>
                        M&G Real Estate Limited is registered in England and Wales under number 3852763 with its
                        registered office at 10 Fenchurch Avenue, London EC3M 5AG.
                    </p>
                    <p>
                        Prudential Pensions Limited is registered in England and Wales under number 992726, with its
                        registered office at 10 Fenchurch Avenue, London EC3M 5AG. Prudential Pensions Limited is
                        authorised by the Prudential Regulation Authority and regulated by the Financial Conduct Authority and the Prudential Regulation Authority, and is registered on the FCA’s register, No.
                        110434 (<a href="https://register.fca.org.uk/">https://register.fca.org.uk/</a>).
                    </p>
                `);

            }
            else {
                processedDisclaimers.push(`
                    <p>
                        <b>The value of investments will fluctuate, which will cause fund prices to fall as well as rise
                        and you may not get back the original amount you invested.</b>
                    </p>
                    <p>
                        Issued by M&G Securities Limited which is authorised and regulated by the Financial Conduct
						Authority and provides investment products. The company’s registered office is 10 Fenchurch
						Avenue, London EC3M 5AG. Registered in England No. 90776 and on the FCA’s Financial
                        Services Register no. 122057 (<a href="https://register.fca.org.uk/">https://register.fca.org.uk/</a>).
                    </p>
                `);
            }
        }

        let htmlText = { __html: processedDisclaimers.join("") };
        return this.findAndReplaceDate(this.props.date, htmlText);
    }

    render() {
        let { disclaimer, appParams } = this.props;
        if (!disclaimer) {
            return <div></div>;
        }

        return (
            <div className={ styles.disclaimer_text } dangerouslySetInnerHTML={ this.getDisclaimer() }></div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/client/assets/Disclaimer/Disclaimer.tsx